import { render } from "./ReportesLayout.vue?vue&type=template&id=dead942c&scoped=true"
import script from "./ReportesLayout.vue?vue&type=script&lang=js"
export * from "./ReportesLayout.vue?vue&type=script&lang=js"

import "./ReportesLayout.vue?vue&type=style&index=0&id=dead942c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dead942c"]])

export default __exports__